"use client";

import Link, { LinkStyle, LinkType } from "@/components/common/link/link";
import css from "./resource-footer.module.scss";
import { useState } from "react";

const ResourceFooter = () => {
  const [isShow, setShow] = useState<boolean>(false);
  const trackButtonClick = (label: string | undefined) => {
    if (window.dataLayer) {
      setShow(true);
      window.dataLayer.push({
        event: `feedabck_${label}`,
        category: "CTA",
        action: "click",
        label: label,
      });
    }
  };
  const handleButtonClick = (
    label: string | undefined,
    e: React.MouseEvent,
  ) => {
    trackButtonClick(label);
    e.preventDefault();
  };

  return (
    <div className="w-full">
      {!isShow && (
        <div className={css.resourceFooter}>
          <h2 className={css.resourceFooterTitle}>
            Was this information helpful?
          </h2>
          <div className={css.resourceFooterContent}>
            <Link
              onClick={(e) => handleButtonClick("Yes", e)}
              href={"#"}
              linkType={LinkType.BUTTON}
              linkStyle={LinkStyle.SECONDARY}
              className="!w-full md:!w-auto"
            >
              <span className="text-[16px] font-medium">Yes</span>
            </Link>

            <Link
              onClick={(e) => handleButtonClick("No", e)}
              href={"#"}
              linkType={LinkType.BUTTON}
              linkStyle={LinkStyle.SECONDARY}
              className="!w-full md:!w-auto"
            >
              <span className="text-[16px] font-medium">No</span>
            </Link>
          </div>
        </div>
      )}
      {isShow && (
        <div
          className={`${css.resourceFooter} flex h-[200px] items-center justify-center p-6`}
        >
          <h2 className={css.resourceFooterTitle}>
            Thank you for your feedback!
          </h2>
        </div>
      )}
    </div>
  );
};

export default ResourceFooter;
